module.exports = __webpack_public_path__ + "static/media/sage_logo.15c2404f.svg";